// TODO - move all config variables here
exports.ballGifFilename = 'ball-norepeat.gif';
exports.completedTaskMoveDelay = 5000;
exports.pageUpDownMoveFactor = 10; // Move cursor by X tasks up/down when pressing PgUp/PgDn
